import {
  AssessmentFormSectionModel,
  AssessmentSectionModel,
} from "../../../services/api/types/forms/models/AssessmentSectionModel";

type SectionModel = AssessmentSectionModel | AssessmentFormSectionModel;
interface PageModel<T extends SectionModel> {
  id: string;
  sections: T[];
}

export function assessmentSectionToPaginatedSections<T extends SectionModel>(
  sections: T[],
): { nextPage: number; paginatedSections: PageModel<T>[] } {
  let pageId = 1;
  // Normalize questions and keep sections flat for the form
  // Unlinking the sections from the paginatedSections array
  const normalizedSections: T[] = (sections ?? []).map((section) => ({
    ...section,
    questions: (section.questions ?? []).map((question) => ({
      ...question,
      id: question.id,
    })),
  }));

  // Build 2D array grouped by page number (page 1 => index 0)
  const paginatedSections: PageModel<T>[] = [];
  for (const section of normalizedSections) {
    // Get the page array index and ensure it is at least 0
    const idx = Math.max(0, (section.page_nr ?? 1) - 1);
    // Ensure the array at this index exists
    if (!paginatedSections[idx]) {
      paginatedSections[idx] = { id: `${pageId}`, sections: [] };
      pageId++;
    }
    // Add the section to the array
    paginatedSections[idx].sections.push(section);
  }

  return { nextPage: pageId, paginatedSections };
}
